import { apiPath } from '../../constants';
import { addSuccessMessage } from 'actions';
import { axios, apiRequestOptions, transformHttpResponse, errorRequestHandler } from 'utils';

/*
 * THE REPRESENTATIVE ROLE (25 Oct 2026). Not kept in the store: the profiles
 * list re-reads itself after a change and shows the role from there.
 */
const request = (api, body, params) => dispatch =>
    axios(apiRequestOptions(api, body, { params }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            dispatch(errorRequestHandler(error));
            return Promise.reject(error);
        });

/** Add the role to a profile, or change its federations. */
export const saveRepresentative = (profileId, representativeId, payload) => dispatch =>
    dispatch(representativeId
        ? request(apiPath.REPRESENTATIVE.PATCH, payload, { id: representativeId })
        : request(apiPath.REPRESENTATIVE.POST, { profile: `/api/profiles/${profileId}`, ...payload }))
        .then(data => {
            dispatch(addSuccessMessage('Representative successfully saved'));
            return data;
        });

export const deleteRepresentative = representativeId =>
    request(apiPath.REPRESENTATIVE.DELETE, null, { id: representativeId });

/** {representatives, athletes, recommended} of one application. */
export const fetchApplicationRepresentatives = applicationId =>
    request(apiPath.APPLICATION_REPRESENTATIVES.GET, null, { id: applicationId });

/** The whole list — an empty one clears it. */
export const saveApplicationRepresentatives = (applicationId, profileIds) =>
    request(apiPath.APPLICATION_REPRESENTATIVES.PUT, { profileIds }, { id: applicationId });
